/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { array, string } from "prop-types";
import get from "lodash/get";
import { SearchBox, Link } from "@quintype/components";
// import { format } from "date-fns";

import "./header.m.css";

import HeaderMenuColumn from "../../atoms/header-menu-column";
import HamburgerIcon from "../../atoms/icons/hamburger";
import Close from "../../atoms/icons/close";
import DfpAd from "../../dfp-ad";
import SearchWhite, { Search } from "../../atoms/icons/search";
// import { ResponsiveAdsense } from "../../adsense";

// const desktopTopAdStyles = {
//   display: "inline-block",
//   width: "728px",
//   height: "90px"
// };

// const mobileTopAdStyles = {
//   display: "inline-block",
//   width: "300px",
//   height: "100px"
// };

const searchForm = ({ children }) => {
  return [
    <label styleName="qt-search-label" htmlFor="searchForm" key="1">
      {children}
    </label>,
    <button type="submit" key="2" styleName="search-button">
      {width < 768 && <Search color={"#fff"} />}
      {width > 768 && `search`}
    </button>
  ];
};

class HeaderBase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      navbar: false,
      searchBox: false,
      width: null,
      activeIndex: null
    };

    this.toggleMenuItem = this.toggleMenuItem.bind(this);
  }

  toggleMenuBar = () => {
    this.setState(state => ({ navbar: !state.navbar }));
  };

  toggleMenuItem = index => {
    if (this.state.width < 992) {
      this.state.activeIndex === index ? this.setState({ activeIndex: null }) : this.setState({ activeIndex: index });
    }
    return false;
  };

  parentMenuLinks = headerMenuLinks => {
    return headerMenuLinks.filter(item => {
      return item["parent-id"] === null;
    });
  };

  generateMenuColumns = headerMenuLinks =>
    this.parentMenuLinks(headerMenuLinks).map((parentItemLink, index) => (
      <HeaderMenuColumn
        key={index}
        headerMenuColumn={parentItemLink}
        childItems={parentItemLink.children}
        toggleMenuBar={this.toggleMenuBar}
        menuItemIndex={index}
        showDropDown={this.state.activeIndex === index}
        toggleMenuItem={this.toggleMenuItem}
        currentPath={this.props.currentPath}
      />
    ));

  toggleSearchBox = () => {
    this.setState({
      searchBox: !this.state.searchBox,
      navbar: false
    });
  };

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    const getWindow = global.window || {};
    const pathName = getWindow.location.pathname;
    if (pathName === "/get-apps") {
      document.getElementById("header-top-ad").style.display = "none";
    }
    this.isWidthPresent();
  }

  getDfpAd() {
    return (
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9082438933551282"
        data-ad-slot="3727968367"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    );
  }

  showTopAd() {
    if (["/housing-auction"].includes(this.props.currentPath)) {
      return false;
    }
    return true;
  }

  render() {
    const styleName = cx("", { active: this.props.currentPath === "/" });
    return (
      <div styleName="wrapper">
        <div styleName="logo-row">
          {this.state.width < 768 &&
            !this.state.searchBox && (
              <div styleName="logo">
                <Link aria-label={`${"fpj-logo"}`} href={"/"}>
                  <img src="https://www.freepressjournal.in/Free_Press_Logo.png" height="30px" />
                </Link>
              </div>
            )}
          {this.state.width > 768 && (
            <div styleName="logo">
              <Link aria-label={`${"fpj-logo"}`} href={"/"}>
                <img src="https://www.freepressjournal.in/Free_Press_Logo.png" height="46px" />
                {/* <AppLogo /> */}
              </Link>
            </div>
          )}
          <a href="http://epaper.freepressjournal.in/" styleName="get-app">
            e-paper
          </a>
          {!this.state.searchBox && (
            <div styleName="mobile-search-wrapper">
              <span onClick={this.toggleSearchBox}>
                <SearchWhite />
              </span>
            </div>
          )}
          {this.state.width < 768 &&
            this.state.searchBox && (
              <div styleName="search-wrapper-with-close">
                <SearchBox
                  styleName={`qt-search__form`}
                  template={searchForm}
                  inputId="searchForm"
                  inputRef={input => (this.input = input)}
                  inputClassName="qt-search__form-input"
                  formRef={searchForm => (this.searchForm = searchForm)}
                  onSubmitHandler={this.toggleSearchBox}
                  onEscape={this.toggleSearchBox}
                  placeholder="Search"
                />
                <div onClick={this.toggleSearchBox}>
                  <Close />
                </div>
              </div>
            )}
          {/* <time styleName="date">{format(new Date(), "dddd, MMM D, YYYY")}</time> */}
          <a
            target="_blank"
            rel="noopener noreferrer"
            styleName="e-paper-link-wrapper"
            href="/get-apps"
          >
            <div styleName="e-paper-link">Get App</div>
          </a>
          {this.state.width < 768 &&
            !this.state.searchBox && (
              <HamburgerIcon onMenuToggle={this.toggleMenuBar} isNavbarOpen={this.state.navbar} />
            )}
        </div>
        <nav styleName="navbar">
          {this.state.width < 768 &&
            this.state.navbar && (
              <ul styleName="menu-group">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  styleName="single-item"
                  href="http://epaper.freepressjournal.in/"
                >
                  <div>e-paper</div>
                </a>
                <li styleName={`single-item ${styleName}`}>
                  <Link href="/">
                    <span onClick={this.toggleMenuBar}>Home</span>
                  </Link>
                </li>
                {this.generateMenuColumns(this.props.headerMenuLinks)}
              </ul>
            )}
          {this.state.width > 768 && (
            <ul styleName="menu-group">
              <li styleName={`single-item ${styleName}`}>
                <Link href="/">Home</Link>
              </li>
              {this.generateMenuColumns(this.props.headerMenuLinks)}
            </ul>
          )}
          <span styleName="search-wrapper" onClick={this.toggleSearchBox}>
            <Search />
          </span>
        </nav>
        {this.state.width > 768 &&
          this.state.searchBox && (
            <div styleName="search-wrapper-with-close">
              <SearchBox
                styleName={`qt-search__form`}
                template={searchForm}
                inputId="searchForm"
                inputRef={input => (this.input = input)}
                inputClassName="qt-search__form-input"
                formRef={searchForm => (this.searchForm = searchForm)}
                onSubmitHandler={this.toggleSearchBox}
                onEscape={this.toggleSearchBox}
                placeholder="Search"
              />
              <div onClick={this.toggleSearchBox} styleName="close-wrapper">
                <Close />
              </div>
            </div>
          )}
        <div styleName="top-ad" id="header-top-ad">
          {this.state.width > 768 ? (
            <DfpAd adtype="FPJ_Homepage_Top_728x90" />
          ) : (
            <DfpAd adtype="FPJ_Homepage_Mobile_Top_300x250" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    headerMenuLinks: get(state, ["qt", "data", "navigationMenu", "headerMenuLinks"], []),
    currentPath: get(state, ["qt", "currentPath"], "")
  };
};

HeaderBase.propTypes = {
  copyrightText: string,
  headerMenuLinks: array,
  currentPath: string
};

const HeaderRow = connect(mapStateToProps)(HeaderBase);

export default HeaderRow;
